/* BIÉDE Japan default currency session preference fix v2026-09-15-1 */
(function () {
  const manualMarketStorageKey = 'biede_manual_market_selection_session';
  const shopify = window.Shopify;
  const activeCurrency = shopify && shopify.currency ? shopify.currency.active : null;

  if (!shopify || shopify.designMode) return;

  const currentUrl = new URL(window.location.href);
  const explicitCountry = (currentUrl.searchParams.get('country') || '').toUpperCase();

  if (/^[A-Z]{2}$/.test(explicitCountry) && explicitCountry !== 'JP') {
    try {
      window.sessionStorage.setItem(manualMarketStorageKey, explicitCountry);
    } catch (error) {
      // The explicit country in the URL still takes priority when storage is unavailable.
    }

    return;
  }

  try {
    const selectedCountry = window.sessionStorage.getItem(manualMarketStorageKey);
    if (explicitCountry === 'JP') {
      window.sessionStorage.removeItem(manualMarketStorageKey);
    } else if (
      /^[A-Z]{2}$/.test(selectedCountry || '') &&
      selectedCountry !== 'JP' &&
      selectedCountry === shopify.country
    ) {
      return;
    }
  } catch (error) {
    // Continue with location detection when storage is unavailable.
  }

  if (shopify.country === 'JP' && activeCurrency === 'JPY') return;

  const root = shopify.routes && shopify.routes.root ? shopify.routes.root : '/';
  const suggestionUrl =
    root +
    'browsing_context_suggestions.json?country[enabled]=true&country[exclude]=' +
    encodeURIComponent(shopify.country || '');

  fetch(suggestionUrl, {
    credentials: 'same-origin',
    headers: { Accept: 'application/json' },
  })
    .then(function (response) {
      if (!response.ok) throw new Error('Localization suggestion request failed');
      return response.json();
    })
    .then(function (context) {
      const detectedCountry =
        context && context.detected_values && context.detected_values.country
          ? context.detected_values.country.handle
          : null;

      if (detectedCountry !== 'JP') return;

      const language = (shopify.language || document.documentElement.lang || 'ja').toLowerCase();
      let languageRoot = language.split('-')[0];

      if (languageRoot === 'zh') {
        languageRoot = /(?:^|-)(?:tw|hk|hant)(?:-|$)/.test(language) ? 'zh-hant' : 'zh-hans';
      }

      const japanRoot = '/' + languageRoot + '-jp';
      const currentRoot = new URL(root, window.location.origin).pathname.replace(/\/$/, '');
      let relativePath = window.location.pathname;

      if (relativePath === japanRoot || relativePath.indexOf(japanRoot + '/') === 0) {
        if (activeCurrency !== 'JPY' && explicitCountry !== 'JP') {
          currentUrl.searchParams.set('country', 'JP');
          window.location.replace(currentUrl.pathname + currentUrl.search + currentUrl.hash);
        }
        return;
      }

      if (
        currentRoot &&
        currentRoot !== '/' &&
        (relativePath === currentRoot || relativePath.indexOf(currentRoot + '/') === 0)
      ) {
        relativePath = relativePath.slice(currentRoot.length) || '/';
      } else {
        relativePath =
          relativePath.replace(/^\/(?:ja|en|zh)(?:-(?:[a-z]{2}|hans|hant))?(?=\/|$)/i, '') || '/';
      }

      if (relativePath.charAt(0) !== '/') relativePath = '/' + relativePath;

      const targetUrl = japanRoot + relativePath + window.location.search + window.location.hash;
      window.location.replace(targetUrl);
    })
    .catch(function () {
      // Keep the visitor's current market when Shopify can't determine a location.
    });
})();
